import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";
import type { DataImportChangesFilterValue } from "../../../../../../api/types/dataImportTypes";

interface Props {
  value: DataImportChangesFilterValue | undefined;
  onChange: (value: DataImportChangesFilterValue | undefined) => void;
  allCount: number | undefined;
  changesCount: number | undefined;
  validationErrorsCount: number | undefined;
  applicationErrorsCount: number | undefined;
  excludedCount: number | undefined;
}

const DataImportChangesListFilter = ({
  value,
  onChange,
  allCount,
  changesCount,
  validationErrorsCount,
  applicationErrorsCount,
  excludedCount,
}: Props) => {
  return (
    <ToggleButtonGroup
      value={value ?? ""}
      exclusive
      onChange={(_, newValue) => onChange(newValue ? (newValue as DataImportChangesFilterValue) : undefined)}
    >
      <ToggleButton value="" sx={{ gap: 1 }}>
        All <BadgeDetached badgeContent={allCount} max={9999999} showZero color="secondary" />
      </ToggleButton>
      <ToggleButton value="Changes" sx={{ gap: 1 }}>
        New & Updated <BadgeDetached badgeContent={changesCount} max={9999999} showZero color="secondary" />
      </ToggleButton>
      <ToggleButton value="ValidationErrors" sx={{ gap: 1 }}>
        Validation Errors{" "}
        <BadgeDetached
          badgeContent={validationErrorsCount}
          max={9999999}
          showZero
          color={validationErrorsCount ? "error" : "secondary"}
        />
      </ToggleButton>
      <ToggleButton value="ApplicationErrors" sx={{ gap: 1 }}>
        Import Errors{" "}
        <BadgeDetached
          badgeContent={applicationErrorsCount}
          max={9999999}
          showZero
          color={applicationErrorsCount ? "error" : "secondary"}
        />
      </ToggleButton>
      <ToggleButton value="Excluded" sx={{ gap: 1 }}>
        Excluded <BadgeDetached badgeContent={excludedCount} max={9999999} showZero color="secondary" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default DataImportChangesListFilter;
